import audioFiles from "../../../assets/audio/audioFiles";

const VoicecallNotificationAudio = ({
  type,
}: {
  type: "ringing" | "hangup";
}) => {
  return (
    <audio
      id="voicecall-notification-audio"
      {...(type === "ringing" ? { loop: true } : {})}
      autoPlay
    >
      <source
        src={
          type === "hangup"
            ? audioFiles.voicecallHangup
            : audioFiles.voicecallRinging
        }
        type="audio/wav"
      />
    </audio>
  );
};
export default VoicecallNotificationAudio;
